import React from 'react';
import { Controller, FieldPath, FieldValues } from 'react-hook-form';
import { StyledQuestionFieldContainer } from '../Questionnaires/QuestionnairePage/components/QuestionViewerEditor/QuestionEditor/styles';
import { InputLabel } from '@material-ui/core';
import { InputField } from '../../healtheraComponents';
import { InputProps } from './types';
import InfoTooltip from '../InfoTooltip';

interface TextEditorProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>
  extends InputProps<TFieldValues, TName> {
  label: string;
  optional?: boolean;
  tooltip?: string;
}

function TextEditor<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name,
  label,
  disabled,
  optional,
  tooltip,
}: TextEditorProps<TFieldValues, TName>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <StyledQuestionFieldContainer>
          <InputLabel error={Boolean(fieldState.error)}>
            {label}
            {tooltip && <InfoTooltip title={tooltip} />}
          </InputLabel>
          <InputField error={fieldState.error?.message} value={field.value || ''} onChange={field.onChange} disabled={disabled} required={!optional} />
        </StyledQuestionFieldContainer>
      )}
    />
  );
}

export default TextEditor;
